import client from '@js/client'
import resources from '@js/resources'
import { camelKeyToSnakeKey, camelKeyToSnakeKeyRecursive, snakeKeyToCamelKeyRecursive } from '@js/str-utils'

const editableProperties = {
  description: '',
  disableEmailNotification: false,
  jobCategory: null,
  links: null,
  location: '',
  roleType: null,
  title: '',
  user: {},
};

const getDefaultState = () => {
  return {
    id: null,
    showedTutorial: false,
    ...editableProperties,
  };
};

const tenantUser = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    getId: state => state.id,
    isAdmin: state => state.roleType === 100,
  },
  mutations: {
    clearTenantUser (state) {
      state.id = null;
      for (const key in editableProperties) {
        state[key] = editableProperties[key];
      }
    },
    initialize (state) {
      Object.assign(state, getDefaultState());
    },
    setTenantUser (state, data) {
      const properties = ['id', ...Object.keys(editableProperties)];
      properties.forEach(function (prop) {
        if (prop in data && prop in state) {
          state[prop] = data[prop];
        }
      });
    },
  },
}

export default tenantUser;
